import "$styles/index.css"
import "$styles/syntax-highlighting.css"

// Import all JavaScript & CSS files from src/_components
import components from "$components/**/*.{js,jsx,js.rb,css}"

const backgroundImages = window.D20_BACKGROUND_IMAGES || []
const backgroundStorageKey = "d20BackgroundImage"
const backgroundMaxAge = 24 * 60 * 60 * 1000
let savedBackground = null

try {
  savedBackground = JSON.parse(localStorage.getItem(backgroundStorageKey) || "null")
} catch {
  localStorage.removeItem(backgroundStorageKey)
}

const savedBackgroundImage = savedBackground?.image
const savedBackgroundIsFresh = Date.now() - (savedBackground?.savedAt || 0) < backgroundMaxAge
const backgroundImage =
  savedBackgroundIsFresh && backgroundImages.includes(savedBackgroundImage)
    ? savedBackgroundImage
    : backgroundImages[Math.floor(Math.random() * backgroundImages.length)]

if (backgroundImage) {
  localStorage.setItem(
    backgroundStorageKey,
    JSON.stringify({
      image: backgroundImage,
      savedAt: Date.now()
    })
  )
  document.body.style.setProperty("--site-background-image", `url("${backgroundImage}")`)
}

console.info("Bridgetown is loaded!")
